import React, { Fragment, useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS } from "../utils/init";
import {
  FetchUserSettings,
  FetchMerchantProfile,
  FetchBasicVerification,
  UploadProfilePicture,
  GetProfilePicture,
  getAuthToken,
  getAuthUuid,
} from "../utils/service";
import { showToast, showHttpError } from "../utils/library";
import PageHeader from "../components/PageHeader";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const styles = {
  pageWrapper: {
    padding: "32px 24px 60px",
  },
  pageHeader: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "28px",
  },
  headerIcon: {
    width: "48px",
    height: "48px",
    borderRadius: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    color: "#7c3aed",
    background: "color-mix(in srgb, #7c3aed, transparent 88%)",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
  },
  // Banner card
  bannerCard: {
    background: "var(--body-color-less)",
    borderRadius: "20px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    overflow: "hidden",
    marginBottom: "24px",
  },
  bannerGradient: {
    height: "120px",
    background:
      "linear-gradient(135deg, var(--btn-color) 0%, color-mix(in srgb, var(--btn-color), #7c3aed 50%) 50%, #7c3aed 100%)",
    position: "relative",
  },
  bannerContent: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    padding: "0 32px 28px",
    marginTop: "-50px",
    paddingTop: "20px",
    position: "relative",
    zIndex: 1,
    flexWrap: "wrap",
    gap: "20px",
  },
  bannerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "28px",
    flexWrap: "wrap",
  },
  // Avatar
  avatarWrapper: {
    position: "relative",
    flexShrink: 0,
  },
  avatar: {
    width: "110px",
    height: "110px",
    borderRadius: "22px",
    overflow: "hidden",
    border: "4px solid var(--body-color-less)",
    background: "gray",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
  },
  avatarImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  avatarInitials: {
    fontSize: "36px",
    fontWeight: "700",
    color: "#fff",
    textTransform: "uppercase",
    userSelect: "none",
  },
  cameraBtn: {
    position: "absolute",
    bottom: "-4px",
    right: "-4px",
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    background: "var(--body-color-less)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    border: "2px solid color-mix(in srgb, var(--text-color), transparent 90%)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    transition: "all 0.2s ease",
  },
  cameraIcon: {
    color: "var(--btn-color)",
    fontSize: "14px",
  },
  // Name section
  nameSection: {
    paddingBottom: "0px",
    paddingTop: "15px",
  },
  fullName: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: "0 0 4px 0",
    lineHeight: 1.3,
    paddingTop: "5px",
  },
  orgName: {
    fontSize: "14px",
    color: "var(--text-color)",
    opacity: 0.55,
    fontWeight: "500",
  },
  // Info cards grid
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "20px",
  },
  infoCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    overflow: "hidden",
  },
  infoCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "18px 24px",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  infoCardIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    flexShrink: 0,
  },
  iconBlue: {
    color: "#3b82f6",
    background: "color-mix(in srgb, #3b82f6, transparent 88%)",
  },
  iconGreen: {
    color: "#10b981",
    background: "color-mix(in srgb, #10b981, transparent 88%)",
  },
  iconAmber: {
    color: "#f59e0b",
    background: "color-mix(in srgb, #f59e0b, transparent 88%)",
  },
  iconPurple: {
    color: "#7c3aed",
    background: "color-mix(in srgb, #7c3aed, transparent 88%)",
  },
  infoCardTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "var(--text-color)",
    margin: 0,
  },
  infoCardBody: {
    padding: "20px 24px",
  },
  infoRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 95%)",
    gap: "16px",
  },
  infoRowLast: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "12px 0 0",
    gap: "16px",
  },
  infoLabel: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--text-color)",
    opacity: 0.45,
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  infoValue: {
    fontSize: "14px",
    fontWeight: "500",
    color: "var(--text-color)",
    textAlign: "right",
    wordBreak: "break-word",
  },
  infoValueMono: {
    fontSize: "13px",
    fontWeight: "500",
    color: "var(--text-color)",
    textAlign: "right",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    wordBreak: "break-all",
  },
  infoValueBadge: (color) => ({
    display: "inline-block",
    padding: "3px 12px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    background: `color-mix(in srgb, ${color}, transparent 88%)`,
    color: color,
  }),
};

const Profile = () => {
  const history = useHistory();
  const fileInputRef = useRef(null);
  const { isTestMode } = useSelector((state) => state);

  const [showLoader, setShowLoader] = useState(false);
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    merchantId: "",
    country: "",
    address: "",
    joiningDate: "",
    profileImage: "",
    organizationName: "",
    city: "",
    state: "",
    zip: "",
  });

  console.log("Rendering Profile with data:", profileData);

  useEffect(() => {
    const token = getAuthToken();
    if (!token) {
      history.push("/");
      return;
    }
    fetchProfileData();
    fetchProfilePicture();
  }, []);

  const fetchProfileData = () => {
    const isSubMerchant =
      localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") != "0";
    const parentMerchantId = localStorage.getItem(
      SITENAMEALIAS + "_parent_merchant_id"
    );
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    setShowLoader(true);

    Promise.all([
      FetchUserSettings({ merchant_id: merchantId }),
      FetchMerchantProfile({ merchant_id: merchantId }),
      FetchBasicVerification({
        merchant_id: isSubMerchant ? parentMerchantId : merchantId,
      }),
    ])
      .then(([userRes, merchantRes, basicRes]) => {
        setShowLoader(false);
        const userData = userRes.data[0];
        const merchantData = merchantRes.data[0];
        const basicData = basicRes.data[0];

        console.log("Profile Data:", userData, merchantData, basicData);

        // if (userData.error !== "0") {
        //   showToast("error", userData.error_msg);
        //   return;
        // }

        const address1 =
          basicData?.address_line_1 || merchantData?.inv_address_line_1 || "";
        const address2 =
          basicData?.address_line_2 || merchantData?.inv_address_line_2 || "";
        const addressParts = [address1, address2].filter(Boolean);

        setProfileData({
          firstName:
            basicData?.owner_first_name ||
            userData.first_name ||
            localStorage.getItem(SITENAMEALIAS + "_first_name") ||
            "",
          lastName:
            basicData?.owner_last_name ||
            userData.last_name ||
            localStorage.getItem(SITENAMEALIAS + "_last_name") ||
            "",
          email:
            userData?.email ||
            localStorage.getItem(SITENAMEALIAS + "_email") ||
            "",
          phoneNo:
            basicData?.phone_no ||
            userData.phone_no ||
            localStorage.getItem(SITENAMEALIAS + "_phoneno") ||
            "",
          merchantId: merchantId || "",
          country: localStorage.getItem(SITENAMEALIAS + "_country") || "",
          businessCountry: basicData?.country || "",
          address: addressParts.join(", ") || "",
          joiningDate: userData.joining_date || userData.created_at || "",
          profileImage: userData.profile_image || "",
          organizationName:
            basicData?.organization_name ||
            merchantData?.organization_name ||
            "",
          city: basicData?.city || merchantData?.inv_city || "",
          state: basicData?.state || merchantData?.inv_state || "",
          zip: basicData?.zip || "",
        });
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const fetchProfilePicture = () => {
    const uuid = getAuthUuid();
    if (!uuid) return;

    GetProfilePicture(uuid)
      .then((res) => {
        if (res.data && res.data.size > 0) {
          const imageUrl = URL.createObjectURL(res.data);
          setProfileData((prev) => ({ ...prev, profileImage: imageUrl }));
        }
      })
      .catch(() => {});
  };

  const handleImageClick = () => {
    if (isTestMode) return;
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!["jpeg", "png"].includes(fileExtension)) {
      showToast("error", "Image should be in .jpeg or .png format only");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      showToast("error", "Image size should be less than 5MB");
      return;
    }

    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    setShowLoader(true);

    UploadProfilePicture(merchantId, file)
      .then((res) => {
        setShowLoader(false);
        const data = res.data;
        if (data.error && data.error !== "0") {
          showToast(
            "error",
            data.error_msg || "Failed to upload profile picture"
          );
          return;
        }
        const localUrl = URL.createObjectURL(file);
        setProfileData((prev) => ({ ...prev, profileImage: localUrl }));
        window.dispatchEvent(
          new CustomEvent("profilePictureUpdated", {
            detail: { imageUrl: localUrl },
          })
        );
        showToast("success", "Profile picture uploaded successfully");
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const fullName =
    `${profileData.firstName} ${profileData.lastName}`.trim() || "User";

  const getInitials = () => {
    const f = profileData.firstName?.charAt(0)?.toUpperCase() || "";
    const l = profileData.lastName?.charAt(0)?.toUpperCase() || "";
    return f + l || "U";
  };

  return (
    <Fragment>
      <div className="container-scroller">
        <Sidebar />
        <Header />
        <div className="main-panel">
          <div style={styles.pageWrapper}>
            {/* Page Header */}
            <PageHeader
              icon="mdi-account-circle"
              title="Profile"
              subtitle="View and manage your account information"
            />

            {/* Banner Card */}
            <div style={styles.bannerCard}>
              <div style={styles.bannerGradient}></div>
              <div style={styles.bannerContent}>
                <div style={styles.bannerLeft}>
                  {/* Avatar */}
                  <div style={styles.avatarWrapper}>
                    <div
                      style={{
                        ...styles.avatar,
                        ...(profileData.profileImage
                          ? { background: "#fff" }
                          : {}),
                        cursor: isTestMode ? "not-allowed" : "pointer",
                      }}
                      onClick={handleImageClick}
                      title={isTestMode ? "Profile picture updates are disabled in Test Mode" : undefined}
                    >
                      {profileData.profileImage ? (
                        <img
                          src={profileData.profileImage}
                          alt="Profile"
                          style={styles.avatarImage}
                        />
                      ) : (
                        <span style={styles.avatarInitials}>
                          {getInitials()}
                        </span>
                      )}
                    </div>
                    <div
                      style={{
                        ...styles.cameraBtn,
                        cursor: isTestMode ? "not-allowed" : "pointer",
                      }}
                      onClick={handleImageClick}
                      title={isTestMode ? "Profile picture updates are disabled in Test Mode" : "Change profile image"}
                      onMouseEnter={(e) => {
                        if (isTestMode) return;
                        e.currentTarget.style.background =
                          "color-mix(in srgb, var(--btn-color), transparent 88%)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background =
                          "var(--body-color-less)";
                      }}
                    >
                      <i
                        className="fas fa-camera"
                        style={styles.cameraIcon}
                      ></i>
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      accept="image/jpeg,image/png,image/gif,image/webp"
                      onChange={handleImageChange}
                    />
                  </div>

                  {/* Name + Org */}
                  <div style={styles.nameSection}>
                    <h3 style={styles.fullName}>{fullName}</h3>
                    {profileData.organizationName && (
                      <div style={styles.orgName}>
                        <i
                          className="fa fa-building"
                          style={{ marginRight: "6px", fontSize: "12px" }}
                        ></i>
                        {profileData.organizationName}
                      </div>
                    )}
                  </div>
                </div>

                {/* Merchant ID badge */}
                <div style={{ paddingBottom: "0px", paddingTop: "15px" }}>
                  <div style={{ fontSize: "10px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", color: "var(--text-color)", opacity: 0.45, marginBottom: "6px" }}>
                    Merchant ID
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={styles.infoValueBadge("#7c3aed")}>
                      <i
                        className="fa fa-fingerprint"
                        style={{ marginRight: "6px", fontSize: "11px" }}
                      ></i>
                      {profileData.merchantId || "N/A"}
                    </span>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(profileData.merchantId || "");
                        showToast("success", "Copied");
                      }}
                      style={{
                        padding: "4px 10px",
                        borderRadius: "7px",
                        border: "1px solid color-mix(in srgb, #7c3aed, transparent 60%)",
                        background: "color-mix(in srgb, #7c3aed, transparent 90%)",
                        color: "#7c3aed",
                        fontSize: "11px",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => { e.target.style.background = "color-mix(in srgb, #7c3aed, transparent 80%)"; }}
                      onMouseLeave={(e) => { e.target.style.background = "color-mix(in srgb, #7c3aed, transparent 90%)"; }}
                    >
                      <i className="fa fa-copy"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Info Cards Grid */}
            <div style={styles.infoGrid}>
              {/* Contact Information */}
              <div style={styles.infoCard}>
                <div style={styles.infoCardHeader}>
                  <div style={{ ...styles.infoCardIcon, ...styles.iconBlue }}>
                    <i className="fa fa-address-card"></i>
                  </div>
                  <h5 style={styles.infoCardTitle}>Contact Information</h5>
                </div>
                <div style={styles.infoCardBody}>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Email</span>
                    <span style={styles.infoValueMono}>
                      {profileData.email || "N/A"}
                    </span>
                  </div>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Phone</span>
                    <span style={styles.infoValueMono}>
                      {profileData.phoneNo || "N/A"}
                    </span>
                  </div>
                  <div style={styles.infoRowLast}>
                    <span style={styles.infoLabel}>Country</span>
                    <span style={styles.infoValue}>
                      {profileData.country ? (
                        <span style={styles.infoValueBadge("#10b981")}>
                          {profileData.country}
                        </span>
                      ) : (
                        "N/A"
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Address Details */}
              <div style={styles.infoCard}>
                <div style={styles.infoCardHeader}>
                  <div style={{ ...styles.infoCardIcon, ...styles.iconGreen }}>
                    <i className="fa fa-map-marker-alt"></i>
                  </div>
                  <h5 style={styles.infoCardTitle}>Business Address Details</h5>
                </div>
                <div style={styles.infoCardBody}>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Address</span>
                    <span style={styles.infoValue}>
                      {profileData.address || "N/A"}
                    </span>
                  </div>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>City</span>
                    <span style={styles.infoValue}>
                      {profileData.city || "N/A"}
                    </span>
                  </div>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>State</span>
                    <span style={styles.infoValue}>
                      {profileData.state || "N/A"}
                    </span>
                  </div>
                  <div style={styles.infoRowLast}>
                    <span style={styles.infoLabel}>Zip Code</span>
                    <span style={styles.infoValueMono}>
                      {profileData.zip || "N/A"}
                    </span>
                  </div>
                  <div style={styles.infoRowLast}>
                    <span style={styles.infoLabel}>Country</span>
                    <span style={styles.infoValue}>
                      {profileData.country ? (
                        <span style={styles.infoValueBadge("#10b981")}>
                          {profileData.businessCountry}
                        </span>
                      ) : (
                        "N/A"
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Account Details */}
              <div style={styles.infoCard}>
                <div style={styles.infoCardHeader}>
                  <div style={{ ...styles.infoCardIcon, ...styles.iconAmber }}>
                    <i className="fa fa-id-badge"></i>
                  </div>
                  <h5 style={styles.infoCardTitle}>Account Details</h5>
                </div>
                <div style={styles.infoCardBody}>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Merchant ID</span>
                    <span style={styles.infoValueMono}>
                      {profileData.merchantId || "N/A"}
                    </span>
                  </div>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Organization</span>
                    <span style={styles.infoValue}>
                      {profileData.organizationName || "N/A"}
                    </span>
                  </div>
                  <div style={styles.infoRowLast}>
                    <span style={styles.infoLabel}>Member Since</span>
                    <span style={styles.infoValue}>
                      <span>
                        {localStorage.getItem(SITENAMEALIAS + "_created_on")}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
        <Loader show={showLoader} />
      </div>
    </Fragment>
  );
};

export default Profile;
